import { escapeRegExp, join, take, toUpper } from "lodash";

const str = (input: any): string => "" + (input || "");

const lower = (input: string) => str(input).toLowerCase();

const removeDiacritics = (input: string) =>
  str(input)
    .replace(/Ã¨|Ã©|Ãª|Ã«|é|è|ê/, "e")
    .replace(/Ã²|Ã³|Ã´|Ãµ|Ã¶|ô/, "o")
    .replace(/Ã¬|Ã®|Ã¯|î/, "i")
    .replace(/Ã |Ã¡|Ã¢|Ã£|Ã¤|Ã¥|Ã¦|à/, "a")
    .replace(/Ã¹|Ãº|Ã»|Ã¼|û|ù/, "u")
    .replace(/ç/, "c");

export const reverseUrl = (url: string) => {
  url = str(url);
  const extension = url.substring(0, url.indexOf("."));
  const body = url.substring(url.indexOf(".") + 1, url.indexOf("/"));
  const rest = url.substring(url.indexOf("/") + 1, url.length);
  return body + "." + extension + "/" + rest;
};

export const stripTags = (input: string) =>
  str(input)
    .replace(/<\S[^><]*>/g, "")
    .trim();

export const search = (a: string, b: string) => {
  const query = new RegExp(lower(removeDiacritics(a)), "i");
  return query.test(b);
};

export const getInitials = (string: string, limit = 2, separator = "") => {
  const occurences = removeDiacritics(stripTags(string)).match(/(?:^|\b)\w/g);
  return toUpper(join(take(occurences, limit), separator));
};

export const stringLineBreakToBr = (text: string = ""): string => {
  return text
    .split(/\r?\n/)
    .reduce((finalText, txt) => (finalText += !txt ? "<br/>" : txt), "");
};

export function boldifyString(string: string, target = "") {
  //do not remove this please, it will add some random <b></b> otherwise..
  if (target.length === 0) return string;
  const regex = new RegExp(escapeRegExp(target), "gi");
  return string.replace(regex, (str: string) => `<b>${str}</b>`);
}

export function highlightSearch(
  str: string,
  target = "", // the substring to search within `str`
  maxLength = 60, // at what point should we start cutting the string
  minLength = 25 // how much padding to leave on the left
) {
  if (!str) return "";
  if (target === "") return str;
  const targetPos = str.indexOf(target);
  const startPadding = Math.max(minLength - target.length, 0);
  const start =
    str.length < maxLength || targetPos < startPadding
      ? 0
      : targetPos - startPadding;

  let res = "";
  if (start > 0) {
    res += "...";
  }
  res += boldifyString(str.slice(start, str.length), target);
  return res;
}

export function capitalizeFirstLetter(str: string = ""): string {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
